import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
} from "recharts";

export default function CustomBarChart(props) {
  return (
    <BarChart
      width={250}
      height={200}
      data={props.data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      {/* <CartesianGrid strokeDasharray="3 3" /> */}
      <XAxis dataKey="name" />
      {/* <YAxis /> */}
      <Tooltip />
      {/* <Legend /> */}
      <Bar dataKey="value" fill="#5FAE8A" />
    </BarChart>
  );
}
